import postMeta from '@front/lib/definitions'

export const postMeta: postMeta = [
    {
        label: 'Informace',
        postType: 'job-position',
        fields: [
            {
                slug: 'area',
                label: 'Oblast',
                placeholder: 'Vybrat oblast',
                type: 'select',
                options: [
                    {
                        label: 'Management',
                        value: 'Management'
                    },
                    {
                        label: 'Výroba',
                        value: 'Výroba'
                    },
                    {
                        label: 'Údržba',
                        value: 'Údržba'
                    },
                    {
                        label: 'Technologie',
                        value: 'Technologie'
                    },
                    {
                        label: 'Kvalita',
                        value: 'Kvalita'
                    },
                    {
                        label: 'Logistika',
                        value: 'Logistika'
                    },
                    {
                        label: 'HR',
                        value: 'HR'
                    },
                    {
                        label: 'IT',
                        value: 'IT'
                    },
                    {
                        label: 'Finance',
                        value: 'Finance'
                    },
                    {
                        label: 'Obchod',
                        value: 'Obchod'
                    },
                    {
                        label: 'Služby',
                        value: 'Služby'
                    },
                    {
                        label: 'Správa nemovitostí',
                        value: 'Správa nemovitostí'
                    },
                ]
            },
            {
                slug: 'locality',
                label: 'Lokalita',
                placeholder: 'Vybrat lokalitu',
                type: 'select',
                options: [
                    {
                        label: 'Bezděčín',
                        value: 'Bezděčín'
                    },
                    {
                        label: 'Liberec',
                        value: 'Liberec'
                    },
                    {
                        label: 'Hodkovice',
                        value: 'Hodkovice'
                    },
                    {
                        label: 'Náchod',
                        value: 'Náchod'
                    },
                    {
                        label: 'Trutnov',
                        value: 'Trutnov'
                    },
                    {
                        label: 'Červený Kostelec',
                        value: 'Červený Kostelec'
                    },
                    {
                        label: 'Plazy',
                        value: 'Plazy'
                    },
                    {
                        label: 'Nové Městé nad Metují',
                        value: 'Nové Městé nad Metují'
                    },
                    {
                        label: 'Mladá Boleslav',
                        value: 'Mladá Boleslav'
                    },
                ]
            },
            {
                slug: 'ozp',
                label: 'OZP',
                type: 'checkbox'
            }
        ]
    }
]